var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeMobileShortComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.951 0c1.128 0 2.04.931 2.04 2.069L20 18.965A1.03 1.03 0 0 1 18.975 20c-.272 0-.533-.109-.725-.303l-3.129-3.405H2.051C.922 16.292 0 15.362 0 14.223V2.07C0 .93.923 0 2.05 0zm-6.033 9.31h-6.92c-.637 0-1.154.52-1.154 1.164 0 .642.517 1.163 1.154 1.163h6.92c.637 0 1.153-.52 1.153-1.163s-.516-1.164-1.153-1.164m3.075-4.655H4.998c-.637 0-1.154.52-1.154 1.164 0 .642.517 1.163 1.154 1.163h9.995c.637 0 1.153-.52 1.153-1.163s-.516-1.164-1.153-1.164"
})));
export default SvgYoutubeMobileShortComment;